import { defineStore } from "pinia";
import { ref } from "vue";
import mitt from "@/application/plugins/mitt";
import { getPeriodsForSelect } from "@/modules/periods/api";

export const usePeriodStore = defineStore("period", () => {
  const hasPeriods = ref(false);
  const isLoaded = ref(false);

  const fetch = async () => {
    const periods = await getPeriodsForSelect();
    hasPeriods.value = periods.length > 0;
    isLoaded.value = true;
    return hasPeriods.value;
  };

  mitt.on("refreshModule", (module) => {
    if (module === "periods") fetch().catch(() => undefined);
  });

  return { hasPeriods, isLoaded, fetch };
});
